// Mapping des sections du backoffice (miroir de courriers/backoffice_permissions.py).
// Sert au guard de navigation et au filtrage des onglets pour les profils restreints.

// Une page peut relever de plusieurs sections (ex. Notifications : sécurité +
// courriers reçus) : l'accès est alors ouvert dès qu'une seule est accordée.
export type SectionSpec = string | string[]

// Section attribuée à chaque route (par nom de route). 'profil' n'est pas gaté.
export const ROUTE_SECTION: Record<string, SectionSpec> = {
  dashboard: 'dashboard',
  statistiques: 'statistiques',
  users: 'users',
  organisation: 'organisation',
  departements: 'organisation',
  services: 'organisation',
  'types-document': 'types_document',
  'suivi-courriers': 'suivi_courriers',
  'rapport-journalier': 'rapport_journalier',
  logs: 'logs',
  audit: 'audit',
  'audit-courrier-timeline': 'audit',
  'audit-user-activity': 'audit',
  'audit-request-correlation': 'audit',
  'audit-archives': 'audit',
  feedback: 'feedback',
  notifications: ['securite', 'notifications'],
  roles: 'roles',
}

// Section attribuée à chaque entrée de navigation de navigation (par id d'onglet).
export const NAV_SECTION: Record<string, SectionSpec> = {
  dashboard: 'dashboard',
  statistiques: 'statistiques',
  users: 'users',
  organisation: 'organisation',
  'types-document': 'types_document',
  'suivi-courriers': 'suivi_courriers',
  'rapport-journalier': 'rapport_journalier',
  feedback: 'feedback',
  logs: 'logs',
  audit: 'audit',
  notifications: ['securite', 'notifications'],
  roles: 'roles',
  // 'profil' : pas de section -> toujours visible
}

export function sectionForRoute(routeName?: string | symbol | null): SectionSpec | undefined {
  if (typeof routeName !== 'string') return undefined
  return ROUTE_SECTION[routeName]
}

// Vrai si au moins une des sections demandées est accordée (ou si la page n'est pas gatée).
export function canAccessSection(
  canSection: (section: string) => boolean,
  spec?: SectionSpec | null,
): boolean {
  if (!spec) return true
  return (Array.isArray(spec) ? spec : [spec]).some((section) => canSection(section))
}
